module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/38_8e89b79e4b34732dd53e65107a9ab7a4.jpg";